import { useCallback, useState } from "react";

const FOCUS_KEY = "porosity.focus";
const seatKey = (gameId) => `porosity.seat.${gameId}`;

function read(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
function write(key, value) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

// Focus dimming: on by default, remembered on this device.
export function useFocusMode() {
  const [on, setOn] = useState(() => read(FOCUS_KEY) !== "off");
  const toggle = useCallback(() => {
    setOn((v) => {
      write(FOCUS_KEY, v ? "off" : "on");
      return !v;
    });
  }, []);
  return [on, toggle];
}

// "This screen plays as": null = shared screen (hot-seat), else a player colour. Per game, per device.
export function useSeat(gameId) {
  const [seat, setSeatState] = useState(() => read(seatKey(gameId)));
  const setSeat = useCallback(
    (color) => {
      write(seatKey(gameId), color || null);
      setSeatState(color || null);
    },
    [gameId],
  );
  return [seat, setSeat];
}
